module.exports = __webpack_public_path__ + "static/media/at.2377663c.svg";